// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2eRegisterPage {
  min-height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  background:
    radial-gradient(circle at top right,
      rgba(109, 40, 217, .5),
      transparent 25%),

    radial-gradient(circle at bottom left,
      rgba(79, 70, 229, .4),
      transparent 30%),

    #050d3d;
}

.e2eRegisterContainer {
  width: 500px;
  max-width: 95%;

  background: white;

  padding: 40px;

  border-radius: 30px;

  box-shadow:
    0 20px 50px rgba(0,0,0,.25);

  position: relative;
}

.e2eBackButton {
  position: absolute;

  top: 20px;
  left: 20px;

  width: 45px;
  height: 45px;

  border: none;

  border-radius: 50%;

  background: #f3f4f6;

  cursor: pointer;
}

.e2eRegisterLogo {
  width: 80px;

  display: block;

  margin: auto;
}

.e2eRegisterTitle {
  text-align: center;

  margin-top: 15px;

  color: #1f2937;
}

.e2eRegisterSubtitle {
  text-align: center;

  color: #6b7280;

  margin-bottom: 25px;
}

.e2eRegisterForm {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.e2eInputGroup {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.e2eInputGroup label {
  font-weight: 600;
}

.e2eInputWrapper {
  display: flex;
  align-items: center;

  gap: 10px;

  border: 1px solid #e5e7eb;

  border-radius: 12px;

  padding: 0 15px;

  height: 55px;
}

.e2eInputWrapper input {
  flex: 1 1;

  border: none;
  outline: none;

  font-size: 15px;
}

.e2eRegisterSubmitBtn {
  height: 55px;

  border: none;

  border-radius: 12px;

  cursor: pointer;

  color: white;

  font-weight: 700;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  background:
    linear-gradient(
      90deg,
      #8b3dff,
      #4169ff
    );
}

.e2eLoginRedirect {
  text-align: center;

  margin-top: 20px;
}

.e2eLoginRedirect span {
  color: #4169ff;

  cursor: pointer;

  font-weight: 700;

  margin-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/styles/newregister.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;;EAEjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;;;;;;;;;WASS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;;EAEd,iBAAiB;;EAEjB,aAAa;;EAEb,mBAAmB;;EAEnB;+BAC6B;;EAE7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,SAAS;EACT,UAAU;;EAEV,WAAW;EACX,YAAY;;EAEZ,YAAY;;EAEZ,kBAAkB;;EAElB,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;EACE,WAAW;;EAEX,cAAc;;EAEd,YAAY;AACd;;AAEA;EACE,kBAAkB;;EAElB,gBAAgB;;EAEhB,cAAc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;;EAEd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,SAAS;;EAET,yBAAyB;;EAEzB,mBAAmB;;EAEnB,eAAe;;EAEf,YAAY;AACd;;AAEA;EACE,SAAO;;EAEP,YAAY;EACZ,aAAa;;EAEb,eAAe;AACjB;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,mBAAmB;;EAEnB,eAAe;;EAEf,YAAY;;EAEZ,gBAAgB;;EAEhB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;;EAET;;;;;KAKG;AACL;;AAEA;EACE,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,eAAe;;EAEf,gBAAgB;;EAEhB,gBAAgB;AAClB","sourcesContent":[".e2eRegisterPage {\n  min-height: 100vh;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background:\n    radial-gradient(circle at top right,\n      rgba(109, 40, 217, .5),\n      transparent 25%),\n\n    radial-gradient(circle at bottom left,\n      rgba(79, 70, 229, .4),\n      transparent 30%),\n\n    #050d3d;\n}\n\n.e2eRegisterContainer {\n  width: 500px;\n  max-width: 95%;\n\n  background: white;\n\n  padding: 40px;\n\n  border-radius: 30px;\n\n  box-shadow:\n    0 20px 50px rgba(0,0,0,.25);\n\n  position: relative;\n}\n\n.e2eBackButton {\n  position: absolute;\n\n  top: 20px;\n  left: 20px;\n\n  width: 45px;\n  height: 45px;\n\n  border: none;\n\n  border-radius: 50%;\n\n  background: #f3f4f6;\n\n  cursor: pointer;\n}\n\n.e2eRegisterLogo {\n  width: 80px;\n\n  display: block;\n\n  margin: auto;\n}\n\n.e2eRegisterTitle {\n  text-align: center;\n\n  margin-top: 15px;\n\n  color: #1f2937;\n}\n\n.e2eRegisterSubtitle {\n  text-align: center;\n\n  color: #6b7280;\n\n  margin-bottom: 25px;\n}\n\n.e2eRegisterForm {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.e2eInputGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.e2eInputGroup label {\n  font-weight: 600;\n}\n\n.e2eInputWrapper {\n  display: flex;\n  align-items: center;\n\n  gap: 10px;\n\n  border: 1px solid #e5e7eb;\n\n  border-radius: 12px;\n\n  padding: 0 15px;\n\n  height: 55px;\n}\n\n.e2eInputWrapper input {\n  flex: 1;\n\n  border: none;\n  outline: none;\n\n  font-size: 15px;\n}\n\n.e2eRegisterSubmitBtn {\n  height: 55px;\n\n  border: none;\n\n  border-radius: 12px;\n\n  cursor: pointer;\n\n  color: white;\n\n  font-weight: 700;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n\n  background:\n    linear-gradient(\n      90deg,\n      #8b3dff,\n      #4169ff\n    );\n}\n\n.e2eLoginRedirect {\n  text-align: center;\n\n  margin-top: 20px;\n}\n\n.e2eLoginRedirect span {\n  color: #4169ff;\n\n  cursor: pointer;\n\n  font-weight: 700;\n\n  margin-left: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
